import { create } from 'zustand';

import type { UserRecord } from '@/api/client';

interface UserState {
  user: UserRecord | null;
  needsOnboarding: boolean;
  setUser: (u: UserRecord) => void;
  setNeedsOnboarding: (v: boolean) => void;
  clear: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  needsOnboarding: false,
  setUser: (user) => set({ user }),
  setNeedsOnboarding: (needsOnboarding) => set({ needsOnboarding }),
  clear: () => set({ user: null, needsOnboarding: false }),
}));
